module.exports = __webpack_public_path__ + "img/table-icon-world.19b95124.png";